import UtagHelper from 'utilities/utagHelper';
import cryptoJS from 'crypto-js';
import { recordPage, RELIABLE } from 'utilities/uTagging';
import { ORIGIN_BY_CHANNEL } from 'constants/uTagConstants/origin';
import { recordEventCustomOnly } from 'utilities/uTagging';
import { getGA4EventKeys } from 'utilities/ga4';

const pageName = '/onboarding/step6/identitySelfieByDefaultWithOption';
const pageNameWithoutBiometrics = '/onboarding/step6/identitySelfieByDefaultWithoutBiometry';

export const doTagPage = (userProfile, withoutBiometrics) => {
    const jointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);
    const docNumberEncrypted = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';

    const custom = {
        ...getGA4EventKeys({
            eventName: 'step_identity',
            pageName: withoutBiometrics ? pageNameWithoutBiometrics : pageName,
            processDetail: 'signatureKey',
            onboardingType: userProfile.investmentType,
        }),
        tipoProceso: 'onboarding',
        identificadorOnboarding: docNumberEncrypted,
        processStep: 'step06',
        processDetail: withoutBiometrics
            ? 'identitySelfieByDefaultWithoutBiometry'
            : 'identitySelfieByDefaultWithOption',
        onboardingR: userProfile.clientRisk || '',
        onboardingIdMethod: RELIABLE[userProfile.identityMethod],
        onboardingOrigin: ORIGIN_BY_CHANNEL[userProfile.channel],
    };

    recordPage(
        withoutBiometrics ? pageNameWithoutBiometrics : pageName,
        undefined,
        userProfile.userId,
        undefined,
        undefined,
        undefined,
        jointHolderInfo,
        undefined,
        undefined,
        userProfile.investmentType,
        custom
    );

    return pageName;
};

export const doTaggingOnCheckboxClick = checked => {
    const action = checked ? 'check' : 'uncheck';

    recordEventCustomOnly({
        action,
        eventCategory: pageName,
        component: 'body',
        format: 'checkbox',
        element: 'acceptDataProcessing',
        eventAction: 'acceptDataProcessingCheckBox',
        eventLabel: action,
    });
};

export const doTaggingPrivacyPolicyLinkClick = () => {
    recordEventCustomOnly({
        eventCategory: pageName,
        action: 'click',
        component: 'body',
        format: 'link',
        element: 'privacyPolicy',
        eventAction: 'clickLink',
        eventLabel: 'privacyPolicyLink',
    });
};

export const doTaggingBiometricsChoiceLinkClick = biometricsSelected => {
    recordEventCustomOnly({
        eventCategory: pageName,
        action: 'click',
        component: 'body',
        format: 'link',
        element: biometricsSelected ? 'returnToBiometricIdentification' : 'checkOtherIdentificationMethod',
        eventAction: 'clickLink',
        eventLabel: biometricsSelected ? 'returnToBiometricIdentificationLink' : 'checkOtherIdentificationMethodLink',
    });
};

export const doTaggingVideoErrorMessage = () => {
    recordEventCustomOnly({
        eventCategory: pageName,
        action: 'open',
        component: 'message/error/acceptDataProcessing',
        format: 'message',
        element: 'full',
        eventAction: 'errorMessageAcceptDataProcessing',
        eventLabel: 'view',
    });
};

export const doTaggingOnBiometricModalOpen = () => {
    recordEventCustomOnly({
        eventCategory: pageName,
        action: 'open',
        component: 'modal/identifyWithoutBiometricData',
        format: 'modal',
        element: 'full',
        eventAction: 'identifyWithoutBiometricData',
        eventLabel: 'open',
    });
};

export const doTaggingOnBiometricModalCancel = isCrossPressed => {
    recordEventCustomOnly({
        eventCategory: pageName,
        action: isCrossPressed ? 'close' : 'click',
        component: 'modal/identifyWithoutBiometricData',
        format: isCrossPressed ? 'cross' : 'link',
        element: isCrossPressed ? 'close' : 'returnToBiometry',
        eventAction: 'identifyWithoutBiometricData',
        eventLabel: isCrossPressed ? 'close' : 'returnToBiometry',
    });
};

export const doTaggingOnBiometricModalConfirm = () => {
    recordEventCustomOnly({
        eventCategory: pageName,
        action: 'click',
        component: 'modal/identifyWithoutBiometricData',
        format: 'button',
        element: 'continueWithoutBiometry',
        eventAction: 'identifyWithoutBiometricData',
        eventLabel: 'continueWithoutBiometry',
    });
};
